import {useApi} from '@/services/useApi';
import {defineStore} from 'pinia';
import {getAuthenticatedRequest} from '@/stores/AuthenticatedRequest.js';

export const useCurrencyPricesStore = defineStore('currencyPrices', {
  state: () => ({}),
  getters: {},
  actions: {
    async action_getPrices() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2044,
      };
      //console.log('action_getPrices Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getPrices Success: ', response);
          return {
            result: true,
            data: response.data.currencyPrices
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_removePrice(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2043,
        "currencyPrice": payload
      };
      console.log('action_removePrice Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_removePrice Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_setPrice(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2042,
        "currencyPrice": payload
      };
      console.log('action_setPrice Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_setPrice Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    }
  }
});
